/**
 * Hand a map link off to the device's own map app.
 *
 * data-map-link is the anchor. Its href is the editor's pasted maps URL and stays the
 * fallback for every platform we don't handle — and for no-JS.
 * data-map-link-apple is the maps.apple.com universal link (iOS, iPadOS, macOS).
 * data-map-link-geo is the geo: URI (Android).
 *
 * Detection has to happen here rather than in PHP: the site is page-cached, so a
 * server-rendered per-user-agent href would be handed to the wrong platform.
 */
const ua = navigator.userAgent
// iPadOS 13+ reports as "Macintosh", so this one test covers iPhone, iPad and Mac.
const isApple = /iPhone|iPad|iPod|Macintosh/.test(ua)
const isAndroid = /Android/.test(ua)

document.querySelectorAll('[data-map-link]').forEach((link) => {
  const { mapLinkApple, mapLinkGeo } = link.dataset

  // maps.apple.com always resolves — the app takes over, or Apple's web map renders.
  // No watchdog needed, so the swap can happen up front.
  if (isApple && mapLinkApple) {
    link.href = mapLinkApple
    return
  }

  if (!isAndroid || !mapLinkGeo) return

  // geo: has no guaranteed handler — in-app browsers (Instagram, LinkedIn) drop it
  // silently. Navigate to the fallback unless the page gets backgrounded first,
  // which is what happens when a map app actually takes over.
  link.addEventListener('click', (event) => {
    event.preventDefault()
    const fallback = link.href
    const timer = setTimeout(() => {
      window.location.href = fallback
    }, 1200)

    document.addEventListener(
      'visibilitychange',
      () => {
        if (document.hidden) clearTimeout(timer)
      },
      { once: true }
    )

    window.location.href = mapLinkGeo
  })
})
